'use client'

import { useLookupsStore } from '@repo/store/useLookupsStore'
import MUIFormControl from '@mui/material/FormControl'
import MUIInputLabel from '@mui/material/InputLabel'
import MUIMenuItem from '@mui/material/MenuItem'
import MUISelect from '@mui/material/Select'
import { useState, useEffect } from 'react'
import type { SelectChangeEvent } from '@mui/material/Select'

const LABEL_ID = 'matter-history-type-label'

export const RetentionPolicySelect = ({ value, onChange, width = '320px', sx }: RetentionPolicySelectProps) => {
  const { retentionPolicies, fetchRetentionPolicies } = useLookupsStore()
  const [isFetching, setIsFetching] = useState(false)

  useEffect(() => {
    if (!retentionPolicies?.length && !isFetching) {
      setIsFetching(true)
      fetchRetentionPolicies()
      setIsFetching(false)
    }
  }, [retentionPolicies])

  const handleChange = (e: SelectChangeEvent<string>) => {
    const v = e.target.value
    onChange(v === '' ? null : v)
  }

  return (
    <MUIFormControl sx={{ width: '100%', ...sx, [`& .MuiFormLabel-root`]: { background: 'white' } }} variant="outlined">
      <MUIInputLabel id={LABEL_ID}>Retention period</MUIInputLabel>
      <MUISelect
        labelId={LABEL_ID}
        label="Custom type"
        multiple={false}
        value={value ?? ''}
        onChange={handleChange}
        sx={{ width: '100%' }}
      >
        {retentionPolicies.map((policy: any) => (
          <MUIMenuItem
            key={policy.retentionPolicyId}
            value={policy.retentionPolicyId}
            sx={{
              margin: '6px 6px',
              borderRadius: '4px',
              cursor: 'pointer',
              width: `calc(${width} - 20px)`
            }}
          >
            {policy.description}
          </MUIMenuItem>
        ))}
      </MUISelect>
    </MUIFormControl>
  )
}

type RetentionPolicySelectProps = {
  value: any
  onChange: (value: any) => void
  width?: string
  sx?: object
}
